import { Text, TextProps } from "@nju/ui";
import { parseMegabytesToGigabytes, parseSecondsToMinutes } from "@nju/utils";

interface IPackageDescriptionProps {
  align: TextProps["align"];
  grantValue: string | undefined;
  isVoicePackage: boolean;
  isDataPackage: boolean;
  isUnlimitedVoicePackage: boolean;
}

export function PackageDescription({
  align,
  grantValue,
  isVoicePackage,
  isDataPackage,
  isUnlimitedVoicePackage,
}: IPackageDescriptionProps) {
  if (isVoicePackage && isUnlimitedVoicePackage) {
    return (
      <Text
        align={align}
        display="block"
        size={{
          "@fromTablet": "xl",
        }}
        weight="bold"
      >
        min./SMS/MMS bez limitu
      </Text>
    );
  }

  if (isVoicePackage && !isUnlimitedVoicePackage && grantValue) {
    return (
      <Text
        align={align}
        display="block"
        size={{
          "@fromTablet": "xl",
        }}
        weight="bold"
      >
        {parseSecondsToMinutes(grantValue)} min./SMS/MMS
      </Text>
    );
  }

  if (isDataPackage && grantValue) {
    return (
      <Text
        align={align}
        display="block"
        size={{
          "@fromTablet": "xl",
        }}
        weight="bold"
      >
        {parseMegabytesToGigabytes(grantValue)} GB
      </Text>
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
